window.initStoreAutocomplete = function() {
  const input = document.getElementById('form-fav-store');
  if (!input) return;

  const sessionToken = new google.maps.places.AutocompleteSessionToken();

  const autocomplete = new google.maps.places.Autocomplete(input, {
    types: ['establishment'],
    componentRestrictions: { country: 'us' },
    sessionToken: sessionToken,
    fields: ['name', 'formatted_address', 'geometry'] 
  });

  autocomplete.addListener('place_changed', function() {
    const place = autocomplete.getPlace();
    
    if (!place.formatted_address) {
      console.warn("No address found for this selection.");
      return;
    }

    // Just set the name and the address directly
    input.value = `${place.name} - ${place.formatted_address}`;
    input.setAttribute('data-full-address', place.formatted_address);
  });
};

function updateRewardProgress(currentPoints) {
  const bars = document.querySelectorAll('.wikid-reward-progress-fill');
  
  bars.forEach(bar => {
    const cost = parseInt(bar.getAttribute('data-cost'));
    const productId = bar.id.replace('reward-progress-', '');
    
    const msgEl = document.getElementById(`reward-status-msg-${productId}`);
    const pctEl = document.getElementById(`reward-pct-${productId}`);
    const btn = document.querySelector(`button[onclick*="${productId}"]`);
    
    // Calculate Percentage
    let pct = Math.floor((currentPoints / cost) * 100);
    let displayPct = pct > 100 ? 100 : pct;

    // Animate Bar & Pct Text
    bar.style.width = displayPct + '%';
    pctEl.innerText = displayPct + '%';

    // Messaging & Button State
    if (currentPoints >= cost) {
      // CELEBRATORY STATE
      msgEl.innerHTML = "✨ READY TO REDEEM!";
      msgEl.style.color = "var(--wikid-accent)";
      bar.style.filter = "hue-rotate(0deg) brightness(1.2)";
      
      if (btn) {
        btn.innerText = "REDEEM NOW";
        btn.style.opacity = "1";
        btn.disabled = false;
      }
    } else {
      // MOTIVATIONAL STATE
      const remaining = cost - currentPoints;
      
      //pick messages based on %
      if (pct < 50) {
        msgEl.innerText = "Nice start! Keep going";
      } else if (pct < 70 && pct >= 50) {
        msgEl.innerText = "Over halfway there!";
      } else {
        msgEl.innerText = "So close! Almost yours";
      }
      
      msgEl.style.color = "inherit";
      bar.style.filter = "grayscale(0.5)"; // Slightly more muted until ready

      if (btn) {
        btn.innerText = `NEED ${remaining.toLocaleString()} MORE`;
        btn.style.opacity = "0.4";
        btn.disabled = true;
      }
    }
  });
}

(function() {
  const CONFIG = window.WIKID_CONFIG || {};
  const API_URL = '/apps/loyalty/WikidLoyaltyHandler';

  // 1. REFRESH DASHBOARD
  async function refreshDashboard() {
    if (!CONFIG.customerId) return;
    
    const params = new URLSearchParams({
      publickey: CONFIG.publicKey,
      customer_cmd: "get_data",
      logged_in_customer_id: CONFIG.customerId,
      email: CONFIG.email
    });

    try {
      const res = await fetch(`${API_URL}?${params.toString()}`);
      const rawJson = await res.json(); 
      const data = await parseWikidData(rawJson);

      if (data && data.status === "success") {
        // Update Core UI

        // 1. Update Overview Balance Pods
          if (document.getElementById('ui-overview-available')) {
              document.getElementById('ui-overview-available').innerText = (data.points || 0).toLocaleString();
            }

            if (document.getElementById('ui-overview-pending')) {
              const pendingPts = data.points_pending || 0;
              document.getElementById('ui-overview-pending').innerText = pendingPts.toLocaleString();
              
              
              document.getElementById('ui-overview-pending').style.opacity = pendingPts > 0 ? "1" : "0.3";
            }
        
            // 2. Handle Promotion Banner
            const promoWrapper = document.getElementById('ui-promo-wrapper');
if (promoWrapper && data.promotions && data.promotions.length > 0) {
  const activePromo = data.promotions[0]; // Take the first active promo
  
  promoWrapper.style.display = 'block';
  promoWrapper.innerHTML = `
    <div class="wikid-promo-banner" style="background: linear-gradient(135deg, #1a2a18 0%, #2b4029 100%); border: 2px solid var(--wikid-accent); padding: 20px; border-radius: 12px; position: relative; overflow: hidden; box-shadow: 0 4px 15px rgba(0,0,0,0.3);">
      <div style="position: absolute; right: -10px; bottom: -10px; font-size: 80px; opacity: 0.1;">🚀</div>
      <h4 style="margin: 0; color: var(--wikid-accent); font-size: 11px; letter-spacing: 2px; font-weight: 800;">ACTIVE PROMOTION</h4>
      <h2 style="margin: 5px 0; font-size: 22px; font-weight: 800;">${activePromo.name}</h2>
      <div style="display: flex; align-items: center; gap: 10px; margin-top: 10px;">
         <span style="font-size: 11px; opacity: 0.8; font-weight: bold;">ENDS IN:</span>
         <span id="ui-promo-timer" style="font-family: monospace; font-weight: bold; background: #000; padding: 4px 10px; border-radius: 4px; color: var(--wikid-accent); border: 1px solid rgba(161, 193, 129, 0.3);">--:--:--</span>
      </div>
    </div>
  `;
  startPromoCountdown(activePromo.end_date, 'ui-promo-timer');

} else if (promoWrapper) {
  promoWrapper.style.display = 'none';
}

// 3. Handle Next Reward Milestone (Scraped from DOM)
const milestoneWrapper = document.getElementById('ui-milestone-wrapper');
if (milestoneWrapper) {
    const currentPoints = data.points || 0;
    
    // Scrape all rewards currently rendered in the rewards tab
    const rewardElements = document.querySelectorAll('.wikid-reward-progress-fill');
    let rewards = [];
    
    rewardElements.forEach(el => {
        const card = el.closest('.wikid-reward-card');
        if (card) {
            rewards.push({
                name: card.querySelector('.wikid-reward-title').innerText.trim(),
                cost: parseInt(el.getAttribute('data-cost'))
            });
        }
    });

    // Sort rewards by cost to find the actual "next" one
    rewards.sort((a, b) => a.cost - b.cost);

    // Find the first reward that costs more than the user currently has
    const nextReward = rewards.find(r => r.cost > currentPoints);

    if (nextReward) {
        milestoneWrapper.style.display = 'block';
        const pointsNeeded = nextReward.cost - currentPoints;
        const progressPercent = Math.min((currentPoints / nextReward.cost) * 100, 100);

        milestoneWrapper.innerHTML = `
            <div style="background: rgba(255,255,255,0.03); padding: 20px; border-radius: 12px; border: 1px dashed rgba(255,255,255,0.1);">
                <div style="display: flex; justify-content: space-between; align-items: flex-end; margin-bottom: 12px;">
                    <div>
                        <div style="font-size: 10px; opacity: 0.5; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 4px;">Next Reward to Unlock</div>
                        <div style="font-size: 18px; font-weight: 800; color: #fff;">${nextReward.name}</div>
                    </div>
                    <div style="text-align: right;">
                        <span style="font-size: 16px; font-weight: 800; color: var(--wikid-accent);">${pointsNeeded.toLocaleString()}</span>
                        <span style="font-size: 11px; opacity: 0.6;"> more points</span>
                    </div>
                </div>
                
                <div style="width: 100%; height: 8px; background: rgba(255,255,255,0.1); border-radius: 10px; overflow: hidden;">
                    <div style="width: ${progressPercent}%; height: 100%; background: var(--wikid-accent); box-shadow: 0 0 15px rgba(161, 193, 129, 0.4); transition: width 1s ease-out;"></div>
                </div>
            </div>
        `;
    } else {
        // Hide if user has earned enough for every available reward
        milestoneWrapper.style.display = 'none';
    }
}

        if (document.getElementById('ui-points-balance')) {
          document.getElementById('ui-points-balance').innerText = (data.points || 0).toLocaleString();
        }
        
        if (document.getElementById('ui-lifetime-points')) {
          document.getElementById('ui-lifetime-points').innerText = (data.lifetime_points || 0).toLocaleString();
        }

        calculateTierProgress(
          parseInt(data.lifetime_points || 0),
          parseInt(data.silver_threshold || 1000),
          parseInt(data.gold_threshold || 5000),
          parseInt(data.platinum_threshold || 10000),
          data.silver_multiplier, 
          data.gold_multiplier, 
          data.platinum_multiplier
        );
        
        updateNavigationBadges(data);
        updateRewardProgress(data.points || 0);
        renderActivitiesGrid(data.activities || []);
      }
    } catch (err) {
      console.error("Loyalty Hub: get_data failed", err);
    }

    // TRIGGER SUB-LOADS INDEPENDENTLY 
    loadActivityHistory();
    loadRedemptions();
  }

  // 2. LOAD REDEMPTIONS (My Codes)
  window.loadRedemptions = async function() {
    const rowContainer = document.getElementById('redemption-rows');
    if (!rowContainer) return;

    const params = new URLSearchParams({
      publickey: CONFIG.publicKey,
      customer_cmd: "get_redemptions",
      logged_in_customer_id: CONFIG.customerId
    });
    
    try {
      const res = await fetch(`${API_URL}?${params.toString()}`);
      const rawJson = await res.json();
      const data = await parseWikidData(rawJson);

      if (data && data.status === "success" && data.redemptions) {
        if (data.redemptions.length === 0) {
          rowContainer.innerHTML = `<tr><td colspan="3" style="text-align:center; padding:20px; opacity:0.5;">No rewards redeemed yet.</td></tr>`;
        } else {
          rowContainer.innerHTML = data.redemptions.map(r => `
            <tr>
              <td class="wikid-text-left" style="font-weight:600; padding: 15px 0;">
                ${r.reward_name}
              </td>
              <td class="wikid-text-center">
                <code style="background: rgba(255,255,255,0.05); padding: 6px 12px; border-radius: 4px; border: 1px dashed var(--wikid-accent); cursor: pointer; color: var(--wikid-accent); font-family: monospace;" 
                      onclick="copyToClipboard('${r.code}', this)">
                  ${r.code}
                </code>
              </td>
              <td class="wikid-text-center">
                <span style="font-size: 10px; text-transform: uppercase; padding: 3px 10px; background: rgba(255,255,255,0.1); border-radius: 10px;">
                  ${r.status || 'Active'}
                </span>
              </td>
            </tr>
          `).join('');
        }

        // CRITICAL: Call the badge update here after data loads!
        updateNavigationBadges(data);
      }
    } catch (err) { 
      console.error("Loyalty Hub: get_redemptions failed", err); 
    }
  };

  // 3. LOAD HISTORY
  window.loadActivityHistory = async function() {
    const historyTable = document.getElementById('history-rows');
    if (!historyTable) return;

    const params = new URLSearchParams({
      publickey: CONFIG.publicKey,
      customer_cmd: "get_history",
      logged_in_customer_id: CONFIG.customerId
    });

    try {
      const res = await fetch(`${API_URL}?${params.toString()}`);
      const rawJson = await res.json();
      const data = await parseWikidData(rawJson);

      if (data && data.status === "success" && data.activities) {
        historyTable.innerHTML = data.activities.map(act => {
          const pts = parseInt(act.points_change || 0);
          return `
            <tr>
              <td style="padding: 15px 0; opacity: 0.7;">${act.date || '---'}</td>
              <td>${act.activity_type || 'Bonus'}</td>
              <td class="${pts >= 0 ? 'pos-pts' : 'neg-pts'}" style="text-align:right;">
                ${pts >= 0 ? '+' : ''}${pts}
              </td>
            </tr>
          `;
        }).join('');
      }
    } catch (err) { 
      console.error("Loyalty Hub: get_history failed", err); 
    }
  };

  // 4. TASK GRID RENDERER
  function renderActivitiesGrid(activities) {
    const grid = document.getElementById('ui-activities-grid');
    if (!grid) return;

    if (!activities || activities.length === 0) {
      grid.innerHTML = `<p style="grid-column: 1/-1; opacity: 0.5; padding: 40px; text-align:center;">No activities available right now.</p>`;
      return;
    }

    grid.innerHTML = activities.map(act => {
      const isComp = act.status === 'completed';
      
      // Icon logic
      const iconHtml = act.icon ? 
        `<img src="${act.icon}" alt="${act.title}">` : 
        `<span style="font-size: 35px;">⭐</span>`;

      return `
        <div class="wikid-activity-card ${isComp ? 'is-completed' : ''}">
          <div class="wikid-activity-icon-wrapper">
            ${iconHtml}
          </div>
          
          <div class="wikid-activity-points">+${act.points} POINTS</div>
          
          <h4 class="wikid-activity-title">${act.title}</h4>
          <p class="wikid-activity-desc">${act.description || ''}</p>
          
          <button class="wikid-btn" 
                  style="width: 100%; margin-top: auto; 
                         background: ${isComp ? '#333' : 'var(--wikid-accent)'}; 
                         color: ${isComp ? '#888' : '#000'};"
                  onclick="handleActivityClick('${act.key}', '${act.action_type}', '${act.modal_id || ''}', '${act.target_url || ''}')"
                  ${isComp ? 'disabled' : ''}>
            ${isComp ? '✓ COMPLETED' : 'START NOW'}
          </button>
        </div>
      `;
    }).join('');
  }

  // 5. THE PARSER (Updated for Image URL Support)
  async function parseWikidData(input) {
    let blob = (typeof input === 'object' && input.result) ? input.result : input;
    const start = "###WIKID_START###", end = "###WIKID_END###";
    
    if (!blob || !blob.includes(start)) return { status: "error" };

    try {
      let jsonString = blob.split(start)[1].split(end)[0];
      
      // Attempt a clean parse first (This is best for URLs)
      try {
        return JSON.parse(jsonString);
      } catch (e) {
        // Fallback: Only unescape if standard JSON.parse fails
        const clean = jsonString.replace(/\\"/g, '"').replace(/\\\//g, '/');
        return JSON.parse(clean);
      }
    } catch (err) {
      console.error("Loyalty Hub: Parser totally failed", err);
      return { status: "error" };
    }
  }

  // Redeem Reward
  window.redeemReward = async function(rewardId, pointCost, rewardName) {
    if (!confirm(`Are you sure you want to spend ${pointCost} points to redeem this reward?`)) return;

    const msgEl = document.getElementById('msg-' + rewardId);
    const btnEl = msgEl.previousElementSibling;
    
    btnEl.disabled = true; 
    msgEl.style.display = 'block'; 
    msgEl.style.color = 'inherit'; 
    msgEl.innerText = "Verifying balance and processing...";

    try {
      const params = new URLSearchParams({ 
        publickey: CONFIG.publicKey, 
        customer_cmd: "redeem_reward", 
        logged_in_customer_id: CONFIG.customerId, 
        reward_id: rewardId,
        reward_name : rewardName
      });
      
      const response = await fetch(`/apps/loyalty/WikidLoyaltyHandler?${params.toString()}`);
      const outerData = await response.json();
      const data = JSON.parse(outerData.result.split("###WIKID_START###")[1].split("###WIKID_END###")[0]);

      if (data.status === "success") {
        msgEl.style.color = "#27ae60"; 
        msgEl.innerHTML = `Success! Your code:<br><strong style="font-size:18px; letter-spacing:1px; color:#fff;">${data.discount_code}</strong><br><span style="font-size:12px; font-weight:normal;">(Automatically applied to checkout!)</span>`;
        fetch(`/discount/${data.discount_code}`);
        refreshDashboard();
      } else {
        msgEl.style.color = "#e74c3c"; 
        msgEl.innerText = data.message || "Failed to process reward."; 
        btnEl.disabled = false;
      }
    } catch (err) {
      console.error(err); 
      msgEl.style.color = "#e74c3c"; 
      msgEl.innerText = "A network error occurred. Please try again."; 
      btnEl.disabled = false;
    }
  };

  // UTILS
  window.copyToClipboard = function(text, el) {
    navigator.clipboard.writeText(text).then(() => {
      const originalText = el.innerText;
      el.innerText = "COPIED!";
      el.style.color = "#fff";
      
      setTimeout(() => { 
        el.innerText = originalText; 
        el.style.color = "var(--wikid-accent)";
      }, 1500);
    });
  };

  window.handleActivityClick = function(key, actionType, modalId, targetUrl) {
    if (actionType === 'INTERNAL_MODAL' && modalId) {
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.style.display = 'flex';
      } else {
        console.error(`Loyalty Hub: Modal with ID "${modalId}" not found in Liquid.`);
      }
    } else if (actionType === 'EXTERNAL_LINK' && targetUrl) {
      window.open(targetUrl, '_blank');
    }
  };

 window.submitWikidActivity = async function(btnEl, activityKey, modalId, msgId) {
    const modal = document.getElementById(modalId);
    const msg = document.getElementById(msgId);
    
    // 1. Gather all inputs inside THIS specific modal
    const inputs = modal.querySelectorAll('input, select, textarea');
    const payload = {};
    let hasEmpty = false;

    inputs.forEach(input => {
      if (input.type === 'radio') {
        // For radio buttons, only add to payload if it is the chosen option
        if (input.checked) {
          payload[input.name] = input.value;
        }
      } else {
        // Standard text/date inputs
        if (!input.value) hasEmpty = true;
        const key = input.id.replace('form-', ''); 
        payload[key] = input.value;
      }
    });

    // Validate that a radio button group was actually selected
    const radioGroups = [...new Set([...modal.querySelectorAll('input[type="radio"]')].map(r => r.name))];
    radioGroups.forEach(name => {
      if (!payload[name]) hasEmpty = true;
    });

    if (hasEmpty) {
      msg.innerText = "Please fill in all fields.";
      msg.style.display = "block";
      msg.style.color = "#ff4444";
      return;
    }

    // 2. UI Feedback
    const originalText = btnEl.innerText;
    btnEl.innerText = "SAVING...";
    btnEl.disabled = true;

    // 3. Send to Zoho
    const params = new URLSearchParams({
      publickey: WIKID_CONFIG.publicKey,
      customer_cmd: "complete_activity",
      activity_key: activityKey,
      logged_in_customer_id: WIKID_CONFIG.customerId,
      payload: JSON.stringify(payload)
    });

    try {
      const res = await fetch(`/apps/loyalty/WikidLoyaltyHandler?${params.toString()}`);
      const data = await parseWikidData(await res.json());

      if (data.status === "success") {
        location.reload(); // Refresh to show points and "Completed" status
      } else {
        throw new Error(data.message || "Server error");
      }
    } catch (err) {
      btnEl.innerText = originalText;
      btnEl.disabled = false;
      msg.innerText = "Error: " + err.message;
      msg.style.display = "block";
    }
  };

 /**
   * Updates the notification badges
   */
  window.updateNavigationBadges = function(data) {
    if (!data) return;

    // --- CONFIGURATION ---
    // Type the exact name of the menu link you want the badge to appear on:
    const linkTargetName = "Wikid Club"; 
    // ---------------------

    let pendingActivities = 0;
    let pendingCodes = 0;
    let affordableCount = 0;

    // 1. Update Activities Badge
    if (data.activities && Array.isArray(data.activities)) {
      pendingActivities = data.activities.filter(a => a.status !== 'completed').length;
      const actBadge = document.getElementById('ui-activities-badge');
      if (actBadge) {
        actBadge.innerText = pendingActivities;
        actBadge.style.display = pendingActivities > 0 ? 'flex' : 'none';
      }
    }
    
    // 2. Update Codes Badge
    if (data.redemptions && Array.isArray(data.redemptions)) {
      pendingCodes = data.redemptions.filter(r => {
        const status = (r.status || 'active').toLowerCase();
        return status !== 'redeemed' && status !== 'used';
      }).length;

      const codeBadge = document.getElementById('ui-codes-badge');
      if (codeBadge) {
        codeBadge.innerText = pendingCodes;
        codeBadge.style.display = pendingCodes > 0 ? 'flex' : 'none';
      }
    }

    // 3. Update Rewards Badge (Affordable Rewards)
    if (data.points !== undefined) {
      const currentPoints = parseInt(data.points) || 0;
      const rewardElements = document.querySelectorAll('.wikid-reward-progress-fill');

      rewardElements.forEach(el => {
        const cost = parseInt(el.getAttribute('data-cost')) || 0;
        if (cost > 0 && currentPoints >= cost) {
          affordableCount++;
        }
      });

      const rewardsBadge = document.getElementById('ui-rewards-badge');
      if (rewardsBadge) {
        rewardsBadge.innerText = affordableCount;
        rewardsBadge.style.display = affordableCount > 0 ? 'flex' : 'none';
      }
    }

 // 4. Update Header Menu Total Badge (Dynamically injected!)
    const totalNotifications = pendingActivities + pendingCodes + affordableCount;
    
    // Find all links on the page, filter for the ones matching our target name
    const menuLinks = Array.from(document.querySelectorAll('a')).filter(a => {
      // We check if the text content includes the name, ignoring extra spaces
      return a.textContent.trim() === linkTargetName;
    });

    menuLinks.forEach(link => {
      // Check if we already created a badge for this specific link element
      let badge = link.querySelector('.wikid-dynamic-header-badge');

      // If not, create the badge and inject it into the link
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'wikid-dynamic-header-badge';
        
        // Inline CSS: Switched from 'absolute' to normal flow with margins to prevent clipping
       badge.style.cssText = `
          display: none; 
          margin-left: 8px; 
          transform: translateY(-2px); 
          background-color: #e83f2cd7; 
          color: #ffffff; 
          font-size: 12px; 
          font-weight: 800; 
          min-width: 20px; 
          height: 20px; 
          border-radius: 50%; 
          align-items: center; 
          justify-content: center; 
          border: 2px solid #000000; 
          z-index: 10;
          line-height: 1;
        `;
        
        link.appendChild(badge);
      }

      // Update the badge number and visibility
      // Notice we use 'inline-flex' here so it sits nicely next to the text
      badge.innerText = totalNotifications;
      badge.style.display = totalNotifications > 0 ? 'inline-flex' : 'none';
    });

  };

  window.closeWikidModal = function(id) {
    document.getElementById(id).style.display = 'none';
  };

  window.switchTab = function(evt, tabId) {
    document.querySelectorAll(".wikid-tab-content").forEach(c => c.classList.remove("active"));
    document.querySelectorAll(".wikid-tab-btn").forEach(b => b.classList.remove("active"));
    document.getElementById(tabId).classList.add("active");
    evt.currentTarget.classList.add("active");
  };

  window.calculateTierProgress = function(lifetime, sThresh, gThresh, pThresh, sMult, gMult, pMult) {
    let currentTier = "Bronze";
    let nextTier = "Silver"; 
    let nextPoints = sThresh; 
    let pct = 0;
    
    const sPct = (parseFloat(sMult || 0) * 100).toFixed(0) + "%";
    const gPct = (parseFloat(gMult || 0) * 100).toFixed(0) + "%";
    const pPct = (parseFloat(pMult || 0) * 100).toFixed(0) + "%";
    let curBonus = "0%", nextBonus = sPct;

    // 1. MATH LOGIC
    if (lifetime < sThresh) {
      currentTier = "Bronze"; nextTier = "Silver"; nextPoints = sThresh;
      pct = (lifetime / sThresh) * 100;
      curBonus = "0%"; nextBonus = sPct;
    } else if (lifetime < gThresh) {
      currentTier = "Silver"; nextTier = "Gold"; nextPoints = gThresh;
      pct = ((lifetime - sThresh) / (gThresh - sThresh)) * 100;
      curBonus = sPct; nextBonus = gPct;
    } else if (lifetime < pThresh) {
      currentTier = "Gold"; nextTier = "Platinum"; nextPoints = pThresh;
      pct = ((lifetime - gThresh) / (pThresh - gThresh)) * 100;
      curBonus = gPct; nextBonus = pPct;
    } else {
      currentTier = "Platinum"; nextTier = "Max"; pct = 100;
      curBonus = pPct;
    }

    // 2. UPDATE TOP LABELS & TIER CLASSES
    const tierWrapper = document.querySelector('.wikid-tier-label');
    const topTierEl = document.getElementById('ui-tier-name');

    if (tierWrapper && topTierEl) {
      tierWrapper.classList.remove('tier-bronze', 'tier-silver', 'tier-gold', 'tier-platinum');
      topTierEl.classList.remove('tier-shine');

      const tierClass = `tier-${currentTier.toLowerCase()}`;
      tierWrapper.classList.add(tierClass);

      if (currentTier !== "Bronze") {
        topTierEl.classList.add('tier-shine');
      }

      topTierEl.innerText = `${currentTier} Member`;
    }

    // 3. UPDATE PROGRESS BAR (Consolidated)
    const bar = document.getElementById('ui-progress-bar');
    if (bar) {
      const tierColors = { "Bronze": "#cd7f32", "Silver": "#c0c0c0", "Gold": "#ffd700", "Platinum": "#e5e4e2" };
      bar.style.backgroundColor = tierColors[currentTier];
      bar.style.width = Math.min(pct, 100) + "%";
    }

    // 4. UPDATE TIER MESSAGE
    const msgEl = document.getElementById('ui-tier-message');
    if (msgEl) {
      msgEl.innerHTML = pct >= 100 ? 
        `YOU'RE A <span>PLATINUM LEGEND</span>!` : 
        `ONLY <span>${(nextPoints - lifetime).toLocaleString()}</span> MORE POINTS TO UNLOCK <span>${nextTier.toUpperCase()}</span> & <span>${nextBonus} BONUS</span> ON POINTS EARNED!`;
    }

    // 5. UPDATE BOTTOM LABELS
    const curLbl = document.getElementById('ui-current-tier-label');
    if (curLbl) curLbl.innerText = currentTier;

    const nextLbl = document.getElementById('ui-next-tier-label');
    if (nextLbl) {
      nextLbl.innerText = pct >= 100 ? "Goal Reached" : `${nextTier} at ${nextPoints.toLocaleString()} points`;
    }
  };

  document.addEventListener('DOMContentLoaded', refreshDashboard);
})();


function startPromoCountdown(endDateStr, elementId) {
    const second = 1000, minute = second * 60, hour = minute * 60, day = hour * 24;
    const countDown = new Date(endDateStr).getTime();

    const x = setInterval(function() {
        const now = new Date().getTime();
        const distance = countDown - now;

        const el = document.getElementById(elementId);
        if (!el) {
            clearInterval(x);
            return;
        }

        if (distance < 0) {
            el.innerText = "PROMOTION ENDED";
            clearInterval(x);
            return;
        }

        const days = Math.floor(distance / day);
        const hours = Math.floor((distance % day) / hour);
        const minutes = Math.floor((distance % hour) / minute);
        const seconds = Math.floor((distance % minute) / second);

        el.innerText = `${days}d ${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;
    }, 1000);
}